"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconButton = exports.textButton = exports.secondaryButton = exports.primaryButton = void 0;

var _emotion = require("emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var resetButtonStyles =
/*#__PURE__*/
(0, _emotion.css)("user-select:none;outline:none;position:relative;transition:all 250ms ease 0s;border:none;background:none;cursor:pointer;:disabled{cursor:not-allowed;}");
var buttonStyles =
/*#__PURE__*/
(0, _emotion.css)(resetButtonStyles, "\n  display:inline-flex;align-items:center;justify-content:center;border-radius:2px;text-transform:uppercase;font-size:12px;line-height:1;letter-spacing:0.5px;font-weight:500;color:", _themeConfig.default.color.dark.white, ";padding:12px 16px;text-align:center;&.small{padding:8px 16px;}:hover:enabled{opacity:0.9;}:disabled{opacity:", _themeConfig.default.color.dark.disabledOpacity, ";cursor:not-allowed;}");
var primaryButton =
/*#__PURE__*/
(0, _emotion.css)(buttonStyles, "\n  background-color:", _themeConfig.default.color.dark.sapphire, ";&.with-icon.small{padding:10px 12px;}");
exports.primaryButton = primaryButton;
var secondaryButton =
/*#__PURE__*/
(0, _emotion.css)(buttonStyles, "\n  border:1px solid ", _themeConfig.default.color.dark.sapphire, ";&.with-icon.small{padding:10px 12px;}");
exports.secondaryButton = secondaryButton;
var textButton =
/*#__PURE__*/
(0, _emotion.css)(resetButtonStyles, "\n  text-align:center;font-size:14px;letter-spacing:0.18px;line-height:1;border:none;padding:0;color:", _themeConfig.default.color.dark.amethyst, ";fill:", _themeConfig.default.color.dark.amethyst, ";:hover:enabled{color:#6494ff;fill:#6494ff;}");
exports.textButton = textButton;
var iconButton =
/*#__PURE__*/
(0, _emotion.css)(resetButtonStyles, "\n  width:36px;height:36px;padding:0;border-radius:50%;:hover:enabled{background-color:", _themeConfig.default.color.dark.white0_12, ";}:active:enabled{background-color:", _themeConfig.default.color.dark.white0_18, ";}&.selected{background-color:", _themeConfig.default.color.dark.sapphire, ";:hover:enabled{background-color:", _themeConfig.default.color.dark.sapphire, ";}}&.accent{border-radius:2px;:active:enabled{background-color:", _themeConfig.default.color.dark.sapphire, ";}}");
exports.iconButton = iconButton;